var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'full-height',
      "customContentContainerStyles": Object.assign({
        height: '100%'
      }, _vm.accessibilityMode && {
        height: 'calc(100% - 50px)',
        overflow: 'auto'
      })
    }
  }, [_c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "wood-pieces",
    style: {
      height: '100%',
      width: '100%',
      overflow: _vm.accessibilityMode ? 'unset' : 'auto'
    },
    attrs: {
      "id": "activity-boundary"
    }
  }, [_c('article', {
    class: {
      isInIframe: _vm.userDevice.isInIframe
    },
    attrs: {
      "id": "activity-boundary-content-container"
    }
  }, [_c('div', {
    staticClass: "lettersWithWoodPieces-instructions"
  }, [_c('audio-toggle-button'), _c('h1', [_vm._v("Lets make the letter " + _vm._s(_vm.currentLetter))])], 1), _c('div', {
    staticClass: "test",
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "dragging-container"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    ref: "woodsContainer",
    staticClass: "woods-container"
  }), _c('div', {
    ref: "exerciseWoodsContainer",
    staticClass: "exercise-woods-container"
  })]), _c('div', {
    staticClass: "letters-container"
  }, [_c('div', {
    ref: "sampleContainer",
    staticClass: "sample-container"
  }), _c('div', {
    ref: "exerciseContainer",
    staticClass: "exercise-container"
  })])])]), _c('div', {
    ref: "hiddenDiv",
    staticStyle: {
      "color": "transparent",
      "height": "1px",
      "position": "absolute",
      "top": "0",
      "width": "100%",
      "z-index": "-1000"
    },
    attrs: {
      "role": "region",
      "aria-live": "assertive"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.message) + "\n        ")])])])]), _vm.accessibilityMode ? _c('caption-reader', {
    ref: "playerInstance",
    staticClass: "caption-reader-fixed"
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }